/** Initial Questionnaire dashboard card icon. See SecuritySummaryIcon.tsx for the currentColor rationale. */
export function InitialQuestionnaireIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 8H11V9H5V8Z" fill="currentColor" />
      <path d="M10 11H5V12H10V11Z" fill="currentColor" />
      <path
        d="M4 1C3.44772 1 3 1.44772 3 2V14C3 14.5523 3.44771 15 4 15H12C12.5523 15 13 14.5523 13 14V4.20711C13 3.94189 12.8946 3.68754 12.7071 3.5L10.5 1.29289C10.3125 1.10536 10.0581 1 9.79289 1H4ZM9 2V4C9 4.55228 9.44772 5 10 5H12V14H4V2H9ZM11.7929 4H10V2.20711L11.7929 4Z"
        fill="currentColor"
      />
    </svg>
  );
}
